import React, { useState } from "react";
import "./Contact.css"
import { SectionTitle } from "../components";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import GitHubIcon from '@mui/icons-material/GitHub';
import EmailIcon from '@mui/icons-material/Email';

export const Contact = () => {
  const [hovered, setHovered] = useState(false);
  const [hovered2, setHovered2] = useState(false);
  const [hovered3, setHovered3] = useState(false);

  const addClassHovered = () => {
    if (hovered === false) {
      setHovered(true);
    }
  }

  const addClassHovered2 = () => {
    if (hovered3 === false) {
      setHovered2(true);
    }
  }

  const addClassHovered3 = () => {
    if (hovered3 === false) {
      setHovered3(true);
    }
  }

  return (
    <div className="container contact">
      <div className="section odd contact">
        <SectionTitle title="Contact" />
        <ul className="contactLinks">
          <li className="contactLink" onMouseEnter={addClassHovered}>
            <a href="https://www.linkedin.com/in/bartosz-zborowski-53887522b/" target="_blank" rel="noopener noreferrer" className={hovered ? 'hovered' : ''}><LinkedInIcon /></a>
          </li>
          <li className="contactLink" onMouseEnter={addClassHovered2}>
            <a href="https://www.youtube.com/@1zboro1" target="_blank" rel="noopener noreferrer" className={hovered2 ? 'hovered' : ''}><YouTubeIcon /></a>
          </li>
          <li className="contactLink" onMouseEnter={addClassHovered3}>
            <a href="https://github.com/1zboro1" target="_blank" rel="noopener noreferrer" className={hovered3 ? 'hovered' : ''}><GitHubIcon /></a>
          </li>
        </ul>
        <p>If you want to contact me with my phone number from the resume I’m available <b>from Monday to Friday after 4pm</b>. If that doesn’t suit you please send me an email...</p>
        <p className="emailLink"><a href="mailto:contact@bartosz-zborowski.pl"><EmailIcon />contact@bartosz-zborowski.pl</a></p>
      </div>
    </div>
  );
};
